import script from "./QuickResponseAdditionTemplateConfirm.vue?vue&type=script&lang=ts&setup=true"
export * from "./QuickResponseAdditionTemplateConfirm.vue?vue&type=script&lang=ts&setup=true"

import "./QuickResponseAdditionTemplateConfirm.vue?vue&type=style&index=0&id=fb493ad0&lang=scss"

const __exports__ = script;

export default __exports__